import { FadeIn } from '../components/ui/FadeIn'
import { IncidentsSOSModule } from '../components/landing/modules/IncidentsSOSModule'
import { OperationsModule } from '../components/landing/modules/OperationsModule'
import { RealTimeTrackingModule } from '../components/landing/modules/RealTimeTrackingModule'
import { UserHistoryModule } from '../components/landing/modules/UserHistoryModule'
import { useLanguage } from '../contexts/LanguageContext'

export function ProductShowcase() {
  const { t } = useLanguage()

  return (
    <section id="modulos" className="relative">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8">
        <FadeIn>
          <div className="max-w-2xl">
            <div className="text-xs font-semibold tracking-[0.2em] text-nexus-cyan/80">
              {t('product.label')}
            </div>
            <h2 className="mt-3 text-balance text-3xl font-semibold tracking-tight sm:text-4xl">
              {t('product.title')}
            </h2>
            <p className="mt-3 text-pretty text-white/70">
              {t('product.description')}
            </p>
          </div>
        </FadeIn>

        <div className="mt-10 grid grid-cols-1 gap-4 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <UserHistoryModule />
          </div>
          <div className="lg:col-span-7">
            <IncidentsSOSModule />
          </div>
          <div className="lg:col-span-7">
            <RealTimeTrackingModule />
          </div>
          <div className="lg:col-span-5">
            <OperationsModule />
          </div>
        </div>
      </div>
    </section>
  )
}


